"use client";

import { ReactNode } from "react";
import { ListMarker, ListType } from "./ListMarker";

interface ListItemProps {
  type: ListType;
  /** For numbered lists */
  number?: number;
  /** For todo lists */
  checked?: boolean;
  /** For todo lists */
  onToggle?: () => void;
  /** Indentation level (0-based) */
  indent?: number;
  /** Content */
  children: ReactNode;
  className?: string;
}

// 들여쓰기 레벨별 마진
const indentStyles = [
  "ml-0",
  "ml-6",
  "ml-12",
  "ml-18",
];

export function ListItem({
  type,
  number = 1,
  checked = false,
  onToggle,
  indent = 0,
  children,
  className = "",
}: ListItemProps) {
  const indentClass = indentStyles[Math.min(indent, indentStyles.length - 1)];

  return (
    <div
      className={`
        flex items-start gap-2
        ${indentClass}
        ${className}
      `}
    >
      <div className="flex items-center h-6 flex-shrink-0">
        <ListMarker
          type={type}
          number={number}
          checked={checked}
          onToggle={onToggle}
          indent={indent}
        />
      </div>
      <div className={`flex-1 min-w-0 leading-6 ${checked ? "line-through text-neutral-400" : ""}`}>
        {children}
      </div>
    </div>
  );
}

export { type ListItemProps };
